<template>
  <div
    class="partner-registration-form-card"
    :class="{
      'partner-registration-form-card--min-height': minHeight,
    }"
  >
    <div class="partner-registration-form-card__section">
      <PartnerRegistrationStepsNavigation />
      <slot name="form" />
    </div>
    <!-- show aside only on desktop -->
    <div
      v-if="asideImage"
      class="partner-registration-form-card__aside"
      :style="{ backgroundImage: `url('${asideImage}')` }"
    >
      <PartnerBenefitsBox
        :benefits="benefits"
        class="partner-registration-form-card__benefits"
      />
    </div>
  </div>

  <!-- show benefits below the form on mobile -->
  <PartnerBenefitsBox
    v-if="asideImage"
    :benefits="benefits"
    class="partner-registration-form-card__benefits-mobile"
  />
</template>

<script setup lang="ts">
interface Props {
  asideImage?: string
  minHeight?: boolean
  benefits?: {
    title: string
    items: string[]
  }
}

const { asideImage, minHeight } = defineProps<Props>()
</script>

<style lang="postcss" scoped>
.partner-registration-form-card {
  @apply flex flex-col md:flex-row;
  @apply bg-white text-black rounded-lg shadow-lg;
}

.partner-registration-form-card--min-height {
  @apply min-h-[600px];
}

.partner-registration-form-card__aside {
  @apply hidden md:block;
  @apply bg-cover bg-center bg-no-repeat;
  @apply rounded-r-md;
  @apply w-4/12;
}

.partner-registration-form-card__section {
  @apply space-y-6 p-4 md:p-8 md:w-8/12;
}

.partner-registration-form-card__benefits {
  @apply mt-2 mx-2;
}

.partner-registration-form-card__benefits-mobile {
  @apply block md:hidden;
  @apply mt-4;
}
</style>
